import PaginationControls from "../../../../components/base/PaginationControls";

interface UserPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function UserPagination({
  currentPage,
  totalPages,
  onPageChange,
}: UserPaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <PaginationControls
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
}
